import { client } from "../../services/client/client.gen";
import type { SiteIoConfiguration } from "../../services/client/types.gen";
import { adminAuthHeaders } from "./adminAuthHeaders";

export const listSiteIoConfigurations = async (): Promise<
  SiteIoConfiguration[]
> => {
  const response = await client.get<SiteIoConfiguration[], unknown, true>({
    url: "/v1/admin/site-io-configurations/",
    headers: adminAuthHeaders(),
    throwOnError: true,
  });
  return response.data;
};

export const siteIoConfigurationsBySiteId = (
  configurations: SiteIoConfiguration[],
): Record<string, SiteIoConfiguration> =>
  Object.fromEntries(
    configurations.map((configuration) => [
      configuration.site_id,
      configuration,
    ]),
  );
